import React from "react"
import dayjs from "dayjs"
import Calendar from "../../../components/Calendar/Calendar"
import { FILTER_CONTROL } from "./filterControlClass"

const DATE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'last7Days', label: 'Last 7 Days' },
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'custom', label: 'Custom' },
]

/**
 * DateRangeFilter component for selecting date presets or custom date range
 * @param {string} datePreset - Current selected preset
 * @param {function} setDatePreset - Setter for date preset
 * @param {object} customDateRange - { startDate, endDate }
 * @param {function} setCustomDateRange - Setter for custom date range
 */
const DateRangeFilter = ({ datePreset, setDatePreset, customDateRange, setCustomDateRange }) => {
  const handlePresetChange = (value) => {
    setDatePreset(value)
    if (value !== 'custom') {
      setCustomDateRange({ startDate: null, endDate: null })
    }
  }

  return (
    <div className="flex flex-row gap-3 items-end">
      {/* Segmented Toggle */}
      <div className="flex flex-col">
        <div className="flex rounded-lg border border-divider overflow-hidden">
        {DATE_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => handlePresetChange(opt.value)}
            className={`px-4 h-[46px] text-sm font-medium transition-colors border-r border-divider last:border-r-0
              ${datePreset === opt.value
                ? 'bg-primary-main text-white'
                : 'bg-surface text-text-primary hover:bg-divider'
              }`}
          >
            {opt.label}
          </button>
        ))}
        </div>
      </div>

      {datePreset === 'custom' && (
        <>
          <Calendar
            value={customDateRange.startDate ? dayjs(customDateRange.startDate) : null}
            onChange={(date) => setCustomDateRange(prev => ({ ...prev, startDate: date && date.isValid() ? date.toDate() : null }))}
            label="Start Date"
            withLabel={false}
            width="w-[200px]"
            height="48px"
            parentClassName={`[&_.MuiStack-root]:gap-0 ${FILTER_CONTROL}`}
            inputAndLabelDistance='mb-0'
          />
          <Calendar
            value={customDateRange.endDate ? dayjs(customDateRange.endDate) : null}
            onChange={(date) => setCustomDateRange(prev => ({ ...prev, endDate: date && date.isValid() ? date.toDate() : null }))}
            label="End Date"
            withLabel={false}
            width="w-[200px]"
            height="48px"
            parentClassName={`[&_.MuiStack-root]:gap-0 ${FILTER_CONTROL}`}
            inputAndLabelDistance='mb-0'
          />
        </>
      )}
    </div>
  )
}

export default DateRangeFilter
